
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './introductions-explanation';
const mainimage = '/Images/2people1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "introductions" },
];


const Introductions = () => (
  <GrammarPageLayout
    level="A1"
    title="Introductions"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Introductions Exercises"
    seoDescription="Introduce yourself, ask about others and talk about interests in first conversations. A1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default Introductions;
